@if ( homeVisitRequestIntakeInfo !== null && homeVisitRequestIntakeInfo !== undefined &&
homeVisitRequestIntakeInfo.length > 0 ) {
<div style="padding: 20px 40px 40px 40px">
  <div class="header">Primary Care Patient Intake</div>
  <div class="caption">Patient-Requested Visit</div>
  <div>&nbsp;</div>
  @for (homeVistRequestPatientInfo of homeVisitRequestIntakeInfo; track homeVistRequestPatientInfo) {
  <div>
    <div>
      <span class="label">Patient:&nbsp;</span>
      <span>{{ homeVistRequestPatientInfo.patientName }} • </span>
      <span>{{ homeVistRequestPatientInfo.patientDateOfBirth }}</span>
    </div>
    <div>
      <span class="label">Submitted:&nbsp;</span>
      <span>{{ homeVistRequestPatientInfo.requestedDateTime }}</span>
    </div>
    <div>
      <span class="label">Visit Reason:&nbsp;</span>
      <span>{{ homeVistRequestPatientInfo.visitReason }}</span>
    </div>
    <app-divider></app-divider>
    @if (homeVistRequestPatientInfo.textifiedIntake.length > 0) { @for (homeVistRequestPatientInfoDetail of
    homeVistRequestPatientInfo.textifiedIntake; track homeVistRequestPatientInfoDetail) {
    <div>
      <div class="intakeDetail">
        <div class="label">{{ homeVistRequestPatientInfoDetail.question }}</div>
        <div>{{ homeVistRequestPatientInfoDetail.answer }}</div>
      </div>
    </div>
    }
    <app-divider></app-divider>
    } @if (homeVistRequestPatientInfo.textifiedIntake.length <= 0) {
    <div class="header">This scheduling request does not have an associated intake form.</div>
    }
  </div>
  }
</div>
}
